import React from 'react';
import { Button } from 'antd';
import { Icon } from '@common/components';

type Props = {
  onClick: () => void;
};

export function RolesInfoButton({ onClick }: Props) {
  return (
    <>
      <Button
        type="link"
        className="members-form-roles-info-button"
        onClick={onClick}
      >
        <Icon icon="questionCircle" kind="regular" size="md" color="elm" />
      </Button>
      <style jsx>{`
        :global(.members-form-roles-info-button) {
          padding: 0 5px;
          height: 22px;
        }
        :global(.members-form-roles-info-button svg) {
          vertical-align: text-top;
        }
      `}</style>
    </>
  );
}
